import ProductDemoV1 from './ProductDemoV1';
import ProductDemoV3 from './ProductDemoV3';
import ProductDemoV4 from './ProductDemoV4';

export default { ProductDemoV1, ProductDemoV3, ProductDemoV4 };
